import cx from 'classnames';
import React, { FC, HTMLAttributes } from 'react';
import styles from './Box.module.scss';

export const Box: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, style }) => {
  return <div className={cx(styles.box, className)} style={style}>
    {children}
  </div>;
};
